import { decamelizeKeys } from 'humps';
import { fromJS } from 'immutable';

import resolve from '../../../../api-client';
import {
  getElementsUrl,
  getElementsItemUrl,
  getParticipantUploadsUrl,
  makeFormFile,
} from '../../util';
import {
  CONFIRM_MODAL__DYNAMIC_TEXT,
  ELEMENTS__ADD_UPLOAD,
  ELEMENTS__CREATE,
  ELEMENTS__DELETE,
  ELEMENTS__FETCH,
  ELEMENTS__PATCH,
  ELEMENTS__REPLACE,
  ELEMENTS__REVOKE_UPLOAD,
  ELEMENTS__SEND_UPLOAD,
  ELEMENTS__UPDATE,
} from '../constants';
import { selectRefPagesByElementName, selectElementById } from '../selectors';

const isDeepEqual = (prevState, nextState) => prevState.equals(nextState);

export const elementsAddUpload = (element, upload) => ({
  type: ELEMENTS__ADD_UPLOAD,
  element,
  upload,
});
export const elementsRevokeUpload = (element, upload) => ({
  type: ELEMENTS__REVOKE_UPLOAD,
  element,
  upload,
});
export const elementsSendUpload = ({ upload, ...element }) =>
  resolve({
    element,
    method: 'post',
    type: ELEMENTS__SEND_UPLOAD,
    url: getParticipantUploadsUrl(),
    data: makeFormFile(upload),
  });

export const elementsCreate = (organizationId, surveyId, pageId, parentId, type) =>
  resolve({
    method: 'post',
    pageId,
    data: decamelizeKeys({
      organizationId,
      surveyId,
      pageId,
      parentId,
      type,
    }),
    type: ELEMENTS__CREATE,
    url: getElementsUrl(),
  });

export const elementsBeforeDelete =
  ({ name, properties }, confirm) =>
  (dispatch, getState) => {
    const extra = {
      list: [
        {
          elementName: name,
          pages: selectRefPagesByElementName(getState(), name),
        },
      ],
      type: 'element',
      notice: properties.hasActiveLocks
        ? 'Deleting a reward element may impact participants currently taking this survey.'
        : null,
    };
    return confirm('Delete Element?', CONFIRM_MODAL__DYNAMIC_TEXT, extra);
  };
export function elementsDelete(organizationId, surveyId, pageId, elementId) {
  return resolve({
    elementId,
    method: 'delete',
    pageId,
    data: decamelizeKeys({
      organizationId,
      surveyId,
      pageId,
      id: elementId,
    }),
    type: ELEMENTS__DELETE,
    url: getElementsItemUrl(elementId),
  });
}
export function elementsFetch(organizationId, surveyId) {
  return resolve({
    type: ELEMENTS__FETCH,
    url: getElementsUrl(),
    params: decamelizeKeys({
      organizationId,
      surveyId,
    }),
  });
}
export const elementsUpdate =
  (organizationId, surveyId, pageId, element, newProps, patchOnly = false) =>
  (dispatch) => {
    const elementId = element.id;
    const prevState = fromJS(element);
    const nextState = prevState.mergeDeep(newProps);

    if (patchOnly && isDeepEqual(prevState, nextState)) return Promise.resolve();

    dispatch({
      type: ELEMENTS__PATCH,
      element,
      newProps,
    });

    if (patchOnly) return Promise.resolve();

    const params = decamelizeKeys({
      organizationId,
      surveyId,
      pageId,
      elementId,
    });
    const data = decamelizeKeys(newProps);

    return dispatch(
      resolve({
        method: 'put',
        type: ELEMENTS__UPDATE,
        url: getElementsItemUrl(elementId),
        elementId,
        pageId,
        data,
        params,
      }),
    ).catch(() => {
      dispatch({
        type: ELEMENTS__REPLACE,
        element,
      });
    });
  };

export const elementsAppendImage =
  (organizationId, surveyId, pageId, elementId, image) => (dispatch, getState) => {
    const state = getState();
    const element = selectElementById(state, elementId);
    const nextProps = {
      properties: {
        ...element.properties,
        values: [...element.properties.values, image.id],
      },
    };
    return dispatch(elementsUpdate(organizationId, surveyId, pageId, element, nextProps));
  };
